<template>
    <div class="topbar-container">
        <van-tabs v-model="active" class="tab" line-width="3.3em">
            <van-tab v-for="(item,index) in typeList" :key="index" :title="item"></van-tab>
        </van-tabs>
        <!-- 不直接嵌套在van-tabs中是因为会有滚动bug -->
        <!-- 电子券 -->
        <!-- <electronList v-if="active==0"></electronList> -->
        <!-- 老优惠劵 -->
        <discountList v-if="active==0" :isLogin="isLoginend"></discountList>
        <!-- 车主劵 -->
        <ownerList v-if="active==1" :isLogin="isLoginend"></ownerList>
    </div>
</template>
<script>
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import discountList from "./Discount";
// import electronList from "./Electron";
import ownerList from "./Owner";
export default {
    mixins: [list, user, routeCache],
    components: {
        discountList,
        // electronList,
        ownerList
    },
    name: "UserCouponsHome",
    data() {
        return {
            active: 0,
            typeList: ["优惠劵", "车主卡"]
        };
    },
    created() {
        const me = this,
            params = me.getCache();
        if (params && params.active) {
            me.active = params.active;
        }
    }
};
</script>
<style scoped lang="scss">
</style>
